import { openUrl } from '@/utils/openUrl'

const brl = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
const PLACEHOLDER_IMAGE = require('@/assets/images/default-course-image.png')

// Comportamento comum aos dois formatos de recomendação (menu e card).
// `product` vem normalizado por normalizeRecommendations (recommendation.service).
export default {
  props: {
    product: { type: Object, required: true }
  },
  data () {
    return { imageFailed: false }
  },
  computed: {
    headline () {
      return 'Produto selecionado exclusivamente para você'
    },
    imageSrc () {
      return !this.imageFailed && this.product.imageUrl ? this.product.imageUrl : PLACEHOLDER_IMAGE
    },
    hasDiscount () {
      return this.product.originalPrice != null
    },
    originalPriceLabel () {
      return this.hasDiscount ? brl.format(this.product.originalPrice) : ''
    },
    salePriceLabel () {
      return brl.format(this.product.salePrice)
    }
  },
  watch: {
    'product.imageUrl' () {
      this.imageFailed = false
    }
  },
  methods: {
    onImageError () {
      this.imageFailed = true
    },
    // Abre a checkoutUrl exatamente como veio: os dados do comprador já estão
    // na query. Site → nova aba; app → navegador do sistema (openUrl).
    onBuy () {
      openUrl(this.product.checkoutUrl)
    }
  }
}
